import { useState } from "react"
import { ActionItem } from "slot-definitions"
import { Avatar, Button, ListItemAvatar, Stack } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import Iconify from "minimals-template/components/Iconify"
import { uniqueId } from "library/database/split-id.mjs"
import { createDraft } from "controller/create-draft-schedule"
import { navigate } from "lib/routes/navigate"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { TruncatedListItemText } from "lib/@components/truncatedListItemText"

ActionItem("schedule-out-of-date").plug(<ScheduleOutOfDate />)

function ScheduleOutOfDate({ action }) {
    const [originalId] = useBoundValue("payload.originalId")
    const [originalVersion] = useBoundValue("payload.originalVersion")
    const [lastModifiedScheduleVersion] = useBoundValue("payload.lastModifiedScheduleVersion")
    const [hasCompared] = useBoundValue("payload.hasCompared")
    const isSaved = +hasCompared === +lastModifiedScheduleVersion
    const color = isSaved ? "success" : "warning"
    const [busy, setBusy] = useState(false)
    return (
        <>
            <ListItemAvatar>
                <Avatar sx={{ bgcolor: `${color}.main`, color: `${color}.contrastText` }}>
                    <Iconify icon="fluent-mdl2:upgrade-analysis" />
                </Avatar>
            </ListItemAvatar>
            <TruncatedListItemText
                primary={action.title}
                secondary={`There has been an update to the schedule from which this one is derived.${
                    isSaved ? " The updates have been compared and a draft schedule saved." : ""
                }`}
            />
            <Stack
                alignItems="stretch"
                spacing={1}
                sx={{
                    "& .MuiButton-root": {
                        flex: 1,
                        display: "block",
                    },
                }}
            >
                {isSaved && (
                    <Button
                        onClick={publishGo}
                        color="primary"
                        variant="outlined"
                        size="small"
                        data-cy="publish-changes-action-button"
                    >
                        Publish Changes
                    </Button>
                )}
                <LoadingButton
                    loading={busy}
                    onClick={go}
                    color="primary"
                    variant={isSaved ? undefined : "outlined"}
                    size="small"
                    data-cy="differences-action-button"
                >
                    Differences
                </LoadingButton>
            </Stack>
        </>
    )

    async function publishGo() {
        navigate(`/app/schedules/allDrafts!${uniqueId(action.referenceId)}/edit`)
    }

    async function go() {
        setBusy(true)
        try {
            await createDraft(action.referenceId)
        } catch (error) {
            console.error(error)
            errorSnackbar("Couldn't open the differences. Please try again.")
            setBusy(false)
            return
        }
        navigate(
            `/app/schedules/compare/draft!${uniqueId(action.referenceId)}/scheduleHistory!${uniqueId(
                originalId
            )}-${originalVersion}/schedule!${uniqueId(originalId)}`
        )
    }
}
